// src/components/auth/components/MiniOlsmeMonitor.tsx
import React from "react";
import { Typography } from "antd";
import useOlsmeTimer from "/src/hooks/useOlsmeTimer";
import "./MiniOlsmeMonitor.css";

// Type Definitions
interface OlsmeTimerData {
  timer: string;
  sessionLabel: string;
  nextSession: string;
  isSessionActive: boolean;
}

const { Text } = Typography;

const MiniOlsmeMonitor: React.FC = () => {
  const { timer, sessionLabel, isSessionActive }: OlsmeTimerData = useOlsmeTimer();

  return (
    <div className={`mini-olsme-monitor ${isSessionActive ? "session-active" : ""}`}>
      {isSessionActive && (
        <span className="session-notice" aria-label="OLSME session in progress">
          olsme in progress
        </span>
      )}
      <div className="timer-container">
        <a
          href="/olsme"
          className="olsme-button"
          aria-label="View OLSME details"
        >
          OLSME
        </a>
        <div className="timer-frame">
          <Text className="timer-text">{timer}</Text>
        </div>
        <a
          href="/olsme"
          className="session-link"
          aria-label={`View OLSME session details for ${sessionLabel}`}
        >
          <span className="highlighted-olsme">{sessionLabel}</span>
        </a>
      </div>
    </div>
  );
};

export default React.memo(MiniOlsmeMonitor);